import { ENDPOINT_BASE } from '@/config/endpoints'

/**
 * AI endpoint base. AiController is mounted at
 * `api/v{version}/e/{workspaceSlug}/ai/...`. `ENDPOINT_BASE` already includes
 * `/api/v1.0`, so we only append the workspace + ai segment here.
 */
export const ENDPOINT_AI = (workspaceSlug: string) =>
  `${ENDPOINT_BASE}/e/${workspaceSlug}/ai`
